
<div class="container-fluid banner-wrapper">
    <div class="row">
        <div class="col-lg-12 custom-width banner">
            <h1>Exceptional Woven Fabrics from Jheevarekha Textile</h1>
            <p>Explore our extensive range of woven fabrics, meticulously crafted to meet diverse needs.</p>
            <p-button type="button" label="Explore" styleClass="banner-button p-button-rounded"></p-button>
        </div>
    </div>
</div>
<div class="container-fluid custom-width about">
    <div class="row">
        <div class="col-lg-6">
            <div class="row left-side">
                <div class="col-lg-6 highlights">
                    <div class="card first">
                        <h5>20k Meters</h5>
                        <p>Production <br> per day</p>
                    </div>
                    <div class="card second">
                        <h5>15 Million </h5>
                        <span>Meters</span>
                        <p>Our Annual <br> Production</p>
                    </div>
                </div>
                <div class="col-lg-6 about-bg">
                    <div class="img-wrapper">
                        <img src="/assets/img/home-about.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 about-content">
            <h2>Our Specialization</h2>
            <p>Specializing in Airjet, Rapier, and Ruti 'c' fabrics produced on both shuttleless and shuttle looms, we
                offer unparalleled expertise and precision in woven textile manufacturing.</p>
            <p class="read-more"><a href="">Read More</a></p>
        </div>
    </div>
</div>
<div class="container-fluid  products">
    <div class="row">
        <div class="col-lg-12 prod-title">
                <h2>Products</h2>
<app-products [productCart]="productCart"></app-products>
        </div>
    </div>
</div>
<div class="container-fluid capacity">
    <h2>Our Capacity</h2>
    <div class="capacity-table">
        <table class="table">
            <tbody>
                <tr>
                    <td>Airjet Looms (Toyota)</td>
                    <td>190 Cam</td>
                    <td>72 Nos</td>
                </tr>
                <tr>
                    <td>Airjet Looms (Toyota)</td>
                    <td>190 Dobby</td>
                    <td>16 Nos</td>
                </tr>
                <tr>
                    <td>Airjet Looms (Toyota)</td>
                    <td>280 Cam</td>
                    <td>16 Nos</td>
                </tr>
                <tr>
                    <td>Airjet Looms (Toyota)</td>
                    <td>340 Cam</td>
                    <td>16 Nos</td>
                </tr>
                <tr>
                    <td>Rifa Rapiers Looms</td>
                    <td>340 Cam</td>
                    <td>16 Nos</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>



